import React from "react";
import { Redirect } from "react-router-dom";

// Place path redirects here. Paths here are react-router paths
// https://github.com/pillarjs/path-to-regexp#usage
// These paths are given priority over the src/pages paths.
export default function getRedirects() {
  const redirects: { from: string; to: string }[] = [
    // Canonicalize ja pages
    {
      from: "/(jp|ja-JP)/:path*",
      to: "/ja",
    },
    {
      from: "/ja/:path+",
      to: "/ja",
    },
  ];
  return redirects.map((redirect) => (
    <Redirect key={redirect.from} from={redirect.from} to={redirect.to} exact />
  ));
}
